import BookShow from "components/shared/book/show";
import { FilesField } from "components/shared/form";
import { viewContainer } from "helpers/redux";
import React, { lazy, Suspense } from "react";
import { uploadFile } from "sources/books/platformNews";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class AdminPlatformNewsShow extends BookShow {
    get dropdActions() {
        return [{ text: "Удалить", action: this.actionClose }];
    }

    renderFiles = () => (
        <FilesField
            withoutDownload
            uploadFile={uploadFile}
            modal={this.props.modal}
            files={this.state.data.files}
            onChange={(files) =>
                this.setState({
                    shouldUpdate: true,
                    data: { ...this.state.data, files, fileIds: files.map((file) => file.id) },
                })
            }
        />
    );

    renderBody = () => {
        const { header, section, flags } = this.props.config;
        return (
            <>
                {this.renderField(header)}
                {this.renderSelect(section)}
                {this.renderFlags(flags)}
                {this.renderFiles()}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={this.state.data.text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
                <div className="mt-3">{this.renderButton()}</div>
            </>
        );
    };
}

const ConfiguredShow = (props) => <AdminPlatformNewsShow {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "admin-platform-news");
